import { Injectable } from '@angular/core';
import { API_URL } from '../constants';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class EmailService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public getAllEmailTemplateList(languageId: number, moduleId: number) {
        let url = `Email/GetAllEmailTemplate?id=${languageId}&moduleId=${moduleId}`;
        return super.getAll<any>(url);
    }

    public getAllNonEmailTemplateList() {
        let url = `Email/GetAllNonSystemEmailTemplates`;
        return super.getAll<any>(url);
    }

    public getGetAllAccountEmailTemplateList(id: number) {
        let url = `Email/GetAllAccountEmailTemplate?id=${id}`;
        return super.getAll<any>(url);
    }

    public saveEmailTemplate(data) {
        let url = `Email/SaveEmailTemplate`;
        return super.save<any>(url, data);
    }

    public sendEmail(data) {
        let url = `Email/SendEmail`;
        return super.save<any>(url, data);
    }

    public SendSupport(data) {
        let url = `Email/SendSupport`;
        return super.save<any>(url, data);
    }

    public sendSMS(data) {
        let url = `Email/SendSMS`;
        return super.save<any>(url, data);
    }

    public saveAccountEmailTemplate(data) {
        let url = `Email/SaveAccountEmailTemplate`;
        return super.save<any>(url, data);
    }
    public GetEmailSuggestions(accountId, moduleId) {
        let url = `Email/Suggestions?accountId=${accountId}&moduleId=${moduleId}`
        return super.getAll(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/email.service.ts